<template>
  <el-dialog
    v-el-drag-dialog
    :close-on-click-modal="false"
    class="adaptationModal"
    title="工单派工"
    :visible.sync="dialogVisible"
    width="1100px"
    @close="$reset('form')"
  >
    <el-form v-loading="contentLoading" ref="form" :model="model" :rules="ruleValidate" class="form" label-width="90px">
      <div class="editTitle">基本信息</div>
      <el-row>
        <el-col :span="12">
          <el-form-item label="工单编号">
            <el-input v-model="model.productionOrderNo" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="物料编号">
            <el-input v-model="model.materialNo" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="物料名称">
            <el-input v-model="model.materialName" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="未派工数量">
            <el-input v-model="model.leftQuantity" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="产品工艺路线">
            <el-input v-model="model.routingName" disabled />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="生产中心" prop="workCenterId">
            <el-select v-model="model.workCenterId" placeholder="请选择生产中心">
              <el-option v-for="item in workCenterList" :key="item.pkid" :label="item.workCenterName" :value="item.workCenterId" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="派工数量" prop="quantity">
            <el-input v-model="model.quantity" @input="inputHandle" placeholder="请输入派工数量" :disabled="quantityDisabled" />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="开工时间" prop="planStartTime">
            <el-date-picker
              v-model="model.planStartTime"
              type="datetime"
              style="width: 100%"
              placeholder="请选择开工时间"
              value-format="yyyy-MM-dd HH:mm:ss"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="完工时间" prop="planFinishTime">
            <el-date-picker
              v-model="model.planFinishTime"
              style="width: 100%"
              type="datetime"
              placeholder="请选择完工时间"
              value-format="yyyy-MM-dd HH:mm:ss"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <div class="editTitle">生产BOM</div>
      <Table border stripe :columns="columns" :data="model.bomList"> </Table>
      <div class="editTitle" style="margin-top: 10px">产品工艺信息</div>
      <RouteTree :treeData="treeData" :tableData="treeContent" @tableUpdate="getUpdatedTable"></RouteTree>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitHandle">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import RouteTree from "./RouteTree.vue";
export default {
  components: {
    RouteTree,
  },
  data() {
    return {
      quantityDisabled: false,
      contentLoading: false,
      dialogVisible: false,
      workCenterList: [],
      treeData: [],
      treeContent: [],
      bomListCopy: [],
      model: {
        productionOrderNo: "",
        materialNo: "",
        materialName: "",
        materialId: "",
        leftQuantity: "",
        routeId: "", // 产品工艺id
        routingName: "", // 产品工艺路线名称
        workCenterId: "",
        quantity: "",
        planStartTime: "",
        planFinishTime: "",
        bomList: [],
        routeProcessList: [],
      },
      ruleValidate: {
        quantity: [
          { required: true, message: "请输入派工数量", trigger: "blur" },
          // { pattern: /^[1-9]\d*$/, message: "数字不合法,请输入大于0的整数!" },
        ],
        workCenterId: [{ required: true, message: "请选择生产中心", trigger: "change" }],
        planStartTime: [{ required: true, message: "请选择开工时间", trigger: "change" }],
        planFinishTime: [{ required: true, message: "请选择完工时间", trigger: "change" }],
      },
      columns: [
        {
          title: "物料编号",
          key: "materialNo",
          width: 120,
          align: "center",
        },
        {
          title: "物料名称",
          key: "materialName",
          minWidth: 360,
          tooltip: true,
        },
        {
          title: "数量",
          key: "quantity",
          width: 100,
          align: "center",
        },
        {
          title: "单位",
          key: "unit",
          width: 100,
          align: "center",
        },
      ],
    };
  },

  methods: {
    open(pkid) {
      this.dialogVisible = true;
      this.getData(pkid);
    },

    // 根据生产工单pkid获取工单信息和产品工艺信息
    getData(pkid) {
      this.contentLoading = true;
      this.$http
        .get("basic", `productionOrders/${pkid}`)
        .then((res) => {
          if (res.success) {
            let temp = res.data.bomList;
            temp.forEach((item) => {
              item.quantity = item.quantity / res.data.quantity;
            });
            this.bomListCopy = JSON.stringify(temp);
            this.treeData = res.data.treeData;
            this.model.routeProcessList = this.treeContent = res.data.routeList;
            this.model.productionOrderNo = res.data.productionOrderNo;
            this.model.materialNo = res.data.materialNo;
            this.model.materialName = res.data.materialName;
            this.model.materialId = res.data.materialId;
            this.model.quantity = this.model.leftQuantity = res.data.leftQuantity;
            this.model.routeId = res.data.routeId;
            this.model.routingName = res.data.routingName;
            this.model.planStartTime = res.data.planStartTime;
            this.model.planFinishTime = this.$moment(res.data.planFinishTime).format("YYYY-MM-DD 23:59:59");
            this.getWorkCenterList(this.model.routeId);
            this.isInt(res.data.leftQuantity);
            this.inputHandle();
          }
          this.contentLoading = false;
        })
        .catch(() => {
          this.contentLoading = false;
        });
    },

    // 根据产品工艺id查询生产中心
    getWorkCenterList(routeId) {
      this.$http.get("basic", `rtRoutes/material/workCenters/${routeId}`).then((res) => {
        if (res.success) {
          this.workCenterList = res.data;
          let defaultWorkCenter = this.workCenterList.find((item) => item.isDefault);
          if (defaultWorkCenter) {
            this.model.workCenterId = defaultWorkCenter.workCenterId;
          }
        }
      });
    },

    //派工数量验证通过时获取生产BOM
    inputHandle() {
      let temp = JSON.parse(this.bomListCopy);
      this.$refs.form.validateField(["quantity"], (valid) => {
        // 验证通过
        if (!valid) {
          temp.forEach((item) => {
            item.quantity = item.quantity * this.model.quantity;
          });
          this.model.bomList = temp;
        }
      });
    },

    // 获取更新后的产品工艺信息
    getUpdatedTable(data) {
      this.model.routeProcessList = data;
    },

    // 判断未派工数量是整数还是小数
    isInt(number) {
      if (parseInt(number) === parseFloat(number)) {
        this.quantityDisabled = false;
      } else {
        this.model.quantity = this.model.leftQuantity;
        this.inputHandle();
        this.quantityDisabled = true;
      }
    },

    submitHandle() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.$moment(this.model.planFinishTime).valueOf() <= this.$moment(this.model.planStartTime).valueOf()) {
            this.$confirm("开工时间大于完工时间", "错误", {
              type: "error",
              showCancelButton: false,
            });
            return;
          }
          if (!this.model.bomList.length) {
            this.$confirm("生产BOM不能为空", "错误", {
              type: "error",
              showCancelButton: false,
            });
            return;
          }
          this.$http
            .post("basic", "taskDispatchBills", this.model)
            .then((res) => {
              if (res.success) {
                this.$emit("save-success");
                this.$message.success("添加成功");
                this.dialogVisible = false;
              }
              this.submitLoading = false;
            })
            .catch(() => {
              this.submitLoading = false;
            });
        }
      });
    },
  },
};
</script>
